module.exports = __webpack_public_path__ + "img/icon_benefit_03.62c6f333.svg";